import { ChangeEvent } from 'react';
import { Checkbox } from '@mui/material';
import { Post } from 'lib/types';
import {
  buildPostPath,
} from 'lib/helpers';
import { A } from 'components/A';
import { NetworkIcon } from 'elements/NetworkIcon';
import { PostImg } from 'components/PostImg';

interface Props {
  title: string;
  posts: Post[];
  selectedPostIds: number[];
  onChange: (postIds: number[]) => void;
}

export const SelectedPosts = ({
  title,
  posts,
  selectedPostIds,
  onChange,
}: Props) => {
  const onCheck = (event: ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.target.value);
    onChange(selectedPostIds.filter((s) => s !== value));
  };

  if (posts.length === 0) return null;

  return (
    <div>
      <h1 className="font-semibold mb-2">
        {title}
      </h1>
      {posts.map((post) => {
        const postDetailHref = buildPostPath(post);
        const { account } = post;
        return (
          <div key={post.id} className="flex items-start overflow-hidden border my-2">
            <Checkbox checked onChange={onCheck} value={post.id} />
            <div className="w-full flex gap-2 max-h-28">
              <A href={postDetailHref} target="_blank" title={`open ${account}`}>
                <PostImg post={post} />
              </A>
              <div className="overflow-hidden text-ellipsis pt-2">
                <A href={postDetailHref} target="_blank" className="underline font-semibold">
                  @
                  {account}
                </A>
                <div><NetworkIcon network={post.network} iconColor="color" /></div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
